import { ButtonLink, Size } from "~/components/atoms/Button";
import { RouteIds, useRouteData } from "~/lib/routing";
import { Testable } from "~/lib/testing";
import { captureScrollPosition, getAuthUrls } from "~/lib/utils";

interface Props extends Testable {
    size: Size;
    buttonStyle?: "primary" | "secondary";
    returnTo?: string;
}

export function JoinButton({ "data-testid": testId, size, buttonStyle, returnTo }: Props) {
    const { FEATURES } = useRouteData(RouteIds.ROOT);
    const { signUp } = getAuthUrls({ returnTo });
    const path = FEATURES.BETAExperience ? signUp : "/college-recruiting/signup";

    return (
        <ButtonLink
            className="whitespace-nowrap px-[20px] lg:px-[32px]"
            size={size}
            buttonStyle={buttonStyle ?? "primary"}
            data-testid={`lead-form-cta-${testId}`}
            href={path}
            onClick={captureScrollPosition}
        >
            Join Free Today
        </ButtonLink>
    );
}
